/**
 * Mock billing service.
 *
 * Used by the prototype and the e2e/preview build, which carry no Firebase
 * configuration and must never reach Stripe. Both methods resolve without
 * navigating anywhere, so the pricing and account pages can be exercised in the
 * accessibility and journey tests without leaving the app or contacting a payment
 * provider.
 *
 * @returns {import("../interfaces.js").BillingService}
 */
export function createMockBillingService() {
  return {
    async startCheckout() {
      // No-op: there is no Stripe in the mock backend. A real checkout redirect
      // happens only through the Firebase-backed service.
    },
    async openPortal() {
      // No-op, as above.
    },
  };
}
